/**
 * Firebase configuration and initialization
 */

import { Analytics, getAnalytics, isSupported } from "firebase/analytics";
import { getApps, initializeApp } from "firebase/app";
import {
  browserLocalPersistence,
  getAuth,
  setPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Determine which Firestore database to use based on environment
const databaseName =
  process.env.NEXT_PUBLIC_FIREBASE_FIRESTORE_DATABASE || "development";

export const firebaseConfig = {
  apiKey: (process.env.NEXT_PUBLIC_FIREBASE_API_KEY || "").trim(),
  authDomain: (process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || "").trim(),
  projectId: (process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || "").trim(),
  storageBucket: (process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET || "").trim(),
  messagingSenderId: (
    process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || ""
  ).trim(),
  appId: (process.env.NEXT_PUBLIC_FIREBASE_APP_ID || "").trim(),
  measurementId: (process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID || "").trim(),
};

// Loop through all the keys in the firebaseConfig object and clean out \\n from the end of values.
Object.keys(firebaseConfig).forEach((key) => {
  const configKey = key as keyof typeof firebaseConfig;

  firebaseConfig[configKey] = firebaseConfig[configKey].replace(/\\n$|\n$/, "");
});

const app =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const auth = getAuth(app);

// Set auth persistence explicitly for browser environments
if (typeof window !== "undefined") {
  setPersistence(auth, browserLocalPersistence).catch((error) => {
    console.error("Error setting auth persistence:", error);
  });
}

const db = getFirestore(app, databaseName);
const storage = getStorage(app);
let analytics: Analytics | null = null;

// Initialize Analytics only in browser environment
if (typeof window !== "undefined") {
  isSupported().then((supported) => {
    if (supported && process.env.NEXT_PUBLIC_APP_ENV === "production") {
      analytics = getAnalytics(app);
    }
  });
}

export { analytics, app, auth, databaseName, db, storage };
